import { PerformCreateSearchParams } from '../interfaces/create-search.interface';
import { SearchFacet, SearchFacetValue } from '../../../search/interfaces/search.interface';
import { capitalizeText } from '../../../../common/utils/util';
import { facetSorter } from '../../../search/utils/facet.util';
import { getCreateSearchBody, getCreateSearchUrl } from '../utils/create-search.util';

export async function getCreateSearchApiCall(params: PerformCreateSearchParams): Promise<any> {
  const url = getCreateSearchUrl();
  const body = getCreateSearchBody(params);

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })
    .then((res) => (res.status <= 399 ? res.json() : false))
    .then((json) => {
      if (json) {
        if (json.facets) {
          json.facets.forEach((facet: SearchFacet) => {
            if (facet.label) facet.label = capitalizeText(facet.label);

            facet.facetValues.forEach((value: SearchFacetValue) => {
              if (
                params.fieldValueFilter &&
                params.fieldValueFilter[facet.name] &&
                params.fieldValueFilter[facet.name].includes(value.name)
              ) {
                value.selected = true;
              }

              if (value.children) {
                value.children.sort((v1, v2) => facetSorter(value.name, v1, v2));
                value.children.forEach((child: SearchFacetValue) => {
                  if (
                    params.fieldValueFilter &&
                    params.fieldValueFilter[facet.name] &&
                    params.fieldValueFilter[facet.name].includes(child.name)
                  ) {
                    child.selected = true;
                  }
                });
              }
            });
          });
        }
        return json;
      } else {
        return false;
      }
    });
}
